import { Page as GeistPage } from '@geist-ui/react'
import { Route, Routes } from 'react-router-dom'
import { Home } from './pages/Home'
import { Footer } from './components/Footer'
import { Graphic } from './pages/Graphic'
import { Illustration } from './pages/Illustration'
import { Header } from './components/Header'
import { Project } from './pages/Project'
import { CV } from './pages/CV'

export const Page = () => {
  return (
    <GeistPage style={{ padding: 0, margin: 0, width: '100vw', scrollbarGutter: 'stable both-edges' }}>
      {/* Header */}
      <GeistPage.Header>
        <Header />
      </GeistPage.Header>

      {/* Main content - router */}
      <GeistPage.Content className='main'>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/graphic" element={<Graphic />} />
          <Route path="/graphic/:id" element={<Project type='graphic' />} />
          <Route path="/illustration" element={<Illustration />} />
          <Route path="/illustration/:id" element={<Project type='illustration' />} />
          <Route path="/cv" element={<CV />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </GeistPage.Content>

      {/* Footer */}
      <GeistPage.Footer>
        <Footer />
      </GeistPage.Footer>
    </GeistPage>
  )
}
